import classNames from "classnames"
import { IconSizeClasses } from "themes/default-tailwind/icons"
import { Tooltip } from "themes/default-tailwind/Tooltip"
import { IconColorClasses } from "../icons/constants"

type IconCircleButtonProps = {
    icon: React.FC<React.ComponentProps<"svg">>
    clickHandler: VoidFunction
    iconClasses?: string
    size?: IconSizeClasses
    color?: IconColorClasses
    tooltipMessage?: string
    tooltipMessageClasses?: string
}

export const IconButton = ({
    icon: Icon,
    clickHandler,
    iconClasses: iconClassOverwrites,
    size = IconSizeClasses.Medium,
    color = IconColorClasses.White,
    tooltipMessage,
    tooltipMessageClasses,
}: IconCircleButtonProps) => {
    const containerClasses = classNames("flex cursor-pointer", iconClassOverwrites)
    const iconClasses = classNames(color, size, iconClassOverwrites)

    return (
        <Tooltip
            message={tooltipMessage || ""}
            disabled={tooltipMessage === undefined}
            classes={containerClasses}
            clickHandler={clickHandler}
            messageClasses={tooltipMessageClasses}
        >
            <Icon className={iconClasses} />
        </Tooltip>
    )
}

export default IconButton
